import { createDuplexerChannelName, DuplexerEvent } from '@wix/a11y-wizard-common';
import { useEffect, useMemo } from 'react';
import { useA11yDebug } from '../hooks/use-a11y-debug';
import { useSessionInfoContext } from '../hooks/use-session-info-context';
import { useDuplexerContext } from './use-duplexer-context';
export function useDuplexer(eventHandlers) {
  const {
    socket
  } = useDuplexerContext();
  const {
    msid
  } = useSessionInfoContext();
  const a11yDebug = useA11yDebug();
  const channelInstance = useMemo(() => {
    return socket == null ? void 0 : socket.subscribe(createDuplexerChannelName(msid ?? ''));
  }, [socket, msid]);
  useEffect(() => {
    if (!channelInstance || !eventHandlers) {
      return;
    }
    channelInstance.removeAllListeners();
    Object.values(DuplexerEvent).forEach(eventName => {
      if (!eventHandlers[eventName]) {
        return;
      }
      channelInstance.on(eventName, payload => {
        var _eventHandlers$eventN;
        a11yDebug.addDuplexerRequest == null || a11yDebug.addDuplexerRequest({
          event: eventName,
          payload
        });
        (_eventHandlers$eventN = eventHandlers[eventName]) == null || _eventHandlers$eventN.call(eventHandlers, payload);
      });
    });
  }, [channelInstance, eventHandlers, a11yDebug]);
  useEffect(() => {
    const unsubscribe = async () => {
      channelInstance == null || channelInstance.removeAllListeners();
      await (channelInstance == null ? void 0 : channelInstance.unsubscribe());
    };
    return () => {
      unsubscribe();
    };
  }, [channelInstance]);
  return {
    channelInstance
  };
}
//# sourceMappingURL=use-duplexer.js.map